import {combineReducers} from "redux";


import AuthReducer from "./AuthReducer";
import UserReducer from "./UserReducer";
import TalentSearchReducer from "./TalentSearchReducer";
import LanguageReducer from "./LanguageReducer";
import AnalyticsReducer from "./AnalyticsReducer";
import ArtistsReducer from "./ArtistsReducer";
import MasterCodesReducer from "./MasterCodesReducer";


export default combineReducers({
    auth: AuthReducer,
    language: LanguageReducer,
    analytics: AnalyticsReducer,
    user: UserReducer,
    talentSearch: TalentSearchReducer,
    artists: ArtistsReducer,
    masterCodes: MasterCodesReducer,
   
});